import React from "react";
import SavedTemplate from "./savedTemplate";
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import TemplateNoneBtn from "./templateNoneBtn";
import NoSavedTemplates from "./noSavedTemplates";
import { FilesIcon } from "../../generatorQR/icons";
import useSaveVisualization from "../../../../hooks/useSaveVisualization";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import useTemplateServiceParams from "../../../../hooks/useTemplateServiceParams";

function QrTemplates() {
  const templates = useSelector((state) => state.qrTemplates.templates);
  const lang = useSelector((state) => state.changeLang.language.stepThree);
  const designType = useSelector((state) => state.customizeQr.designType);

  const { saveTemplateVisualisation } = useSaveVisualization();
  const { isTemplateService } = useCurrentLocation();
  const { savedTemplatesSaveUrl } = useTemplateServiceParams();

  const handleSaveQrTemplate = async () => {
    if (isTemplateService) {
      await saveTemplateVisualisation(savedTemplatesSaveUrl);
    } else {
      await saveTemplateVisualisation();
    }
  };

  const filteredTemplates = templates.filter(
    (template) => template.designType === designType
  );

  return (
    <>
      <section
        className="bg-white p-3 p-md-4 mt-3 mt-lg-4 rounded-1"
        id="templates"
      >
        <div className="d-flex justify-content-between alignt-itens-center mb-3 mb-md-4">
          <div className="fw-bold fs-4 text-capitalize">
            {lang.showToggle[5]}
          </div>
          <div
            className="fs-7 text-secondary cursor-pointer d-flex align-items-center"
            onClick={handleSaveQrTemplate}
          >
            <FilesIcon className="me-1" />
            {lang.generator[5]}
          </div>
        </div>
        {filteredTemplates.length ? (
          <Row className="g-2 g-lg-3">
            <TemplateNoneBtn />
            {filteredTemplates.map((template) => (
              <SavedTemplate key={template.id} template={template} />
            ))}
          </Row>
        ) : (
          <NoSavedTemplates saveTemplate={handleSaveQrTemplate} />
        )}
      </section>
    </>
  );
}

export default QrTemplates;
